import { render, staticRenderFns } from "./SendNotificationChangePassword.html?vue&type=template&id=6759a90f&scoped=true&external"
import script from "./SendNotificationChangePassword.vue?vue&type=script&lang=js"
export * from "./SendNotificationChangePassword.vue?vue&type=script&lang=js"
import style0 from "./SendNotificationChangePassword.scss?vue&type=style&index=0&id=6759a90f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6759a90f",
  null
  
)

export default component.exports